module.exports = __webpack_public_path__ + "static/media/alphiner.47af7c9c.png";